export default "__VITE_ASSET__CqiwxXbs__"